<template>
    <div class='header'>
         {{title}}
         <i v-if="title!=''&&title!='互联网医院'&&title!='在线问诊历史'&&isshow==true" class="iconfont icon-houtui" @click="back"></i>
    </div>
</template>

<script>
    export default {
        props:["title"],
        data(){
           return{
               isshow:true
           }
        },
        methods:{
            back(){
                this.$router.go(-1)
            }
        },
        mounted(){
            if(this.$route.query.key=="noshow"){
                this.isshow=false
            }
        }
    }
</script>

<style lang="less" scoped>
.header{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    position: relative;
    i{
        position: absolute;
        left: 1%;
        top: 50%;
        transform: translateY(-50%);
        font-size: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Header/header.vue